import { IconPlaceholder } from '@components/icons/placeholder';
import { Sidebar } from '@components/sidebar';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import {
  ActionFooter,
  ActionHeader,
  ActionSidebarLoading,
  DescriptionFormField,
  SidebarProps,
  createActionForm,
  useCreateActionFormStore,
} from 'ui/journey-builder/node-types/common';

import { FormWithUnsavedChangesPrompt } from '../../journey-builder/unsaved-changes-prompt';

type PlaceholderData = {
  description: string;
};

const Form = createActionForm<PlaceholderData>();

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { data, isLoading } = useJourneyAction(journeyActionId);
  const { t } = useScopedTranslate(sidebarLocale);
  const formStore = useCreateActionFormStore();
  const isDirty = formStore.useIsDirty();

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const handleSave = async (data: PlaceholderData) => {
    await editMutation.mutateAsync({
      description: data.description,
      isAutomatic: true,
      action: 'placeholder',
    });
  };

  if (isLoading || !data) {
    return (
      <ActionSidebarLoading
        title={t('placeholder')}
        icon={IconPlaceholder}
        iconColor="green200"
        {...props}
      />
    );
  }

  return (
    <Sidebar>
      <ActionHeader
        title={t('placeholder')}
        icon={IconPlaceholder}
        iconColor="green200"
        {...props}
      />
      <Sidebar.Content>
        <FormWithUnsavedChangesPrompt store={formStore} onSubmit={handleSave}>
          <Stack space={6}>
            <Stack space={4}>
              <DescriptionFormField defaultValue={data.description} />
            </Stack>
            <ActionFooter
              action={data}
              isDisabled={!isDirty || editMutation.isLoading}
              form={Form}
            />
          </Stack>
        </FormWithUnsavedChangesPrompt>
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    description: 'Description',
    placeholder: 'Placeholder',
  },
};
